__webpack_require__.p = "/svitlana-ripka/";